import type { ButtonHTMLAttributes, ReactNode } from "react";
import { Link, type LinkProps } from "react-router";
import { Spinner } from "../Spinner/Spinner.tsx";
import styles from "./Button.module.css";

type ButtonVariant = "primary" | "secondary" | "destructive" | "segmented";

type ButtonOwnProps = {
  variant?: ButtonVariant;
  children: ReactNode;
};

function buttonClassName(variant: ButtonVariant, className?: string): string {
  return [styles.button, styles[variant], className].filter(Boolean).join(" ");
}

type ButtonProps = ButtonOwnProps &
  ButtonHTMLAttributes<HTMLButtonElement> & {
    /** Показывает индикатор вместо подписи и блокирует повторное нажатие. */
    loading?: boolean;
  };

export function Button({ variant = "primary", loading = false, disabled, className, children, ...rest }: ButtonProps) {
  return (
    <button
      type="button"
      {...rest}
      className={buttonClassName(variant, className)}
      disabled={disabled || loading}
      aria-busy={loading || undefined}
    >
      <span className={styles.label}>{children}</span>
      {loading && <Spinner className={styles.spinner} />}
    </button>
  );
}

type ButtonLinkProps = ButtonOwnProps & Omit<LinkProps, "children">;

/** Ссылка в виде кнопки — для действий, которые ведут на другой экран. */
export function ButtonLink({ variant = "primary", className, children, ...rest }: ButtonLinkProps) {
  return (
    <Link {...rest} className={buttonClassName(variant, className)}>
      {children}
    </Link>
  );
}
